export interface ISelectDefaultCaseLineItemRequest {
  caseId: number
  caseLineItemId: number
}

export class SelectDefaultCaseLineItemRequest implements ISelectDefaultCaseLineItemRequest {
  public caseId: number
  public caseLineItemId: number
}
